import * as React from "react";
const SvgCopy = (props) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.667 11.333H3c-.92 0-1.667-.746-1.667-1.666V3c0-.92.746-1.667 1.667-1.667h6.667c.92 0 1.666.747 1.666 1.667v1.667m-5 10H13c.92 0 1.667-.746 1.667-1.667V6.333c0-.92-.747-1.666-1.667-1.666H6.333c-.92 0-1.666.746-1.666 1.666V13c0 .92.746 1.667 1.666 1.667Z"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCopy;
